import React, { useState, useEffect } from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Button, ButtonGroup, Icon } from 'ui';
import Notice, { NOTICE_TYPES } from 'components/ui/Notice/Notice';
import { REACT_QUERY_STATUS } from 'constants/config';
import { withSkillsClientWrapper } from 'components/shared/Skills/SkillsClientProvider';
import { withReactQueryWrapper } from 'components/shared/ReactQuery/ReactQueryProvider';
import Error from 'components/InPersonTraining/shared/Error';
import { useCreateReadinessSkillCategory } from '../queries/readinessSkills';

const AddCategoryModal = ({ closeModal, setBannerProperties }) => {
  const [categoryName, setCategoryName] = useState('');
  const [hasError, setHasError] = useState(false);
  const [hasNameError, setHasNameError] = useState(false);

  const { mutate, status } = useCreateReadinessSkillCategory({
    name: categoryName,
  });

  const handleInputChange = e => {
    setCategoryName(e.target.value);
  };

  async function handleSubmit() {
    try {
      await mutate({
        name: categoryName,
      });
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    if (status === REACT_QUERY_STATUS.SUCCESS) {
      closeModal();
      setBannerProperties({
        message: (
          <p
            dangerouslySetInnerHTML={{
              __html: t('skills.banner_category_created', {
                category_name: categoryName,
              }),
            }}
          />
        ),
        state: 'success',
      });
    }
    if (status === REACT_QUERY_STATUS.ERROR) {
      setHasError(true);
    }
  }, [status, categoryName, closeModal, setBannerProperties]);

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container  w-90p">
          <div className="TemplateCreationModal-body">
            <div className="TemplateCreationModal-title">
              {t('skills.add_a_new_category')}
            </div>
            {hasError && (
              <div className="mt-24">
                <Notice
                  iconName="alert"
                  type={NOTICE_TYPES.ERROR}
                  bodyText={t('skills.banner_error', {
                    category_name: categoryName,
                  })}
                />
              </div>
            )}
            <input
              value={categoryName}
              onChange={handleInputChange}
              className="NewInput NewInput--white NewInput--fw TemplateCreationModal-inputTitle"
              placeholder={t('skills.type_new_category_name')}
              type="text"
              maxLength="255"
            />
            {hasNameError && (
              <div className="SkillsLibrary-createTextErrorContainer">
                <Error message={t('skills.empty_error')} />
              </div>
            )}
            <ButtonGroup alignEnd className="mt-32">
              <Button type="cancel" onClick={closeModal}>
                {t('common.cancel')}
              </Button>
              <Button
                type="submit"
                className="TemplateCreationModal-submitButton"
                onClick={() =>
                  categoryName ? handleSubmit() : setHasNameError(true)
                }
              >
                {t('skills.add_category')}
              </Button>
            </ButtonGroup>
            <button
              type="button"
              aria-label={t('common.close')}
              className="u-resetBtn ModalTakeover-closeButton"
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default withSkillsClientWrapper(withReactQueryWrapper(AddCategoryModal));
